import classNames from 'classnames';
import React from 'react';
import { Select } from '../Inputs/Select';

interface FormSelectProps {
  options: { value: string; label: string }[];
  label?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  selectContainerClass?: string;
  error?: string;
  search?: boolean;
}

export const FormSelect: React.FC<FormSelectProps> = ({
  options,
  value,
  label,
  onChange,
  disabled = false,
  placeholder = '',
  error,
  search = false,
}) => {
  return (
    <div className="flex w-full flex-col gap-1">
      {!!label && (
        <p className="font-medium text-gray-800 text-base leading-4">{label}</p>
      )}
      <div className="h-9 w-full">
        <Select
          search={search}
          options={options}
          border={true}
          value={value}
          onChange={onChange}
          disabled={disabled}
          containerClassName={classNames('!rounded-lg sm:!px-2.5', {
            '!border-[#E57373]': Boolean(error),
          })}
          dropdownClassName={
            disabled ? '!text-buttons/disable' : '!text-gray-900'
          }
          placeholder={placeholder}
          labelClassName="!text-base !font-semibold truncate max-w-[90%]"
          disabledClassName="!cursor-default pointer-events-none !bg-fill/alternative-1"
          key={`${JSON.stringify(options)}-${value}`}
        />
      </div>
      {!!error && <p className="font-normal text-red-800 text-sm">{error}</p>}
    </div>
  );
};
